import { useContext, useEffect, useState } from 'react'
import styles from './OfferModal.module.scss'
import checkStyles from '../MainLayout/Header/Filter/Location/BidLocationFilter/BidLocationState/BidLocationState.module.scss'
import BidButton from 'elements/BidButton/BidButton'
import BidInput from 'elements/BidInput/BidInput'
import BidSelect from 'elements/BidSelect/BidSelect'
import { AuthContext } from '../../contexts/AuthContext'
import { parse } from 'node-html-parser'

const formatPrice = (itemPrice: any) =>
  isNaN(itemPrice)
    ? 'N/A'
    : '$' +
      itemPrice.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })

const totalPremiumTax = (
  itemPrice: any,
  quantity: any,
  premium: any,
  tax: any
) => {
  const total =
    parseFloat(itemPrice) *
    parseFloat(quantity) *
    (1 + parseFloat(`${premium * 0.01}`)) *
    (1 + parseFloat(`${tax * 0.01}`))

  return formatPrice(total)
}

export default function OfferModal({
  showModal,
  negativeZ,
  auction,
  item,
  type,
  offers,
  setOffers,
  bins,
  setBins,
  toggleModal,
}: any) {
  const { location, premiumRate, terms } = auction
  const title = type === 'bin' ? 'Buy It Now' : 'Make an Offer'
  const priceVal = type === 'bin' ? item.binPrice : 0
  const actionLabel = type === 'bin' ? 'Buy' : 'Submit'
  const [checked, setChecked] = useState<any>(true)
  const [price, setPrice] = useState<any>(0)
  const [qtyOpts, setQtyOpts] = useState<any>([{ label: '0', value: 0 }])
  const [qty, setQty] = useState<any>(1)
  const [comment, setComment] = useState<any>('')
  const [isSubmitted, setIsSubmitted] = useState<any>()
  const [feedback, setFeedback] = useState<string>('')

  const { instance } = useContext<any>(AuthContext)

  const handleAction = async () => {
    let endpoint = ''
    let actionData = {}

    if (type === 'bin') {
      endpoint = 'buyItNowItems'
      actionData = {
        auctionId: auction.id,
        binItemQty: qty,
        itemId: item.id,
      }
    } else {
      endpoint = 'maoItemSubmit'
      actionData = {
        auctionId: auction.id,
        itemId: item.id,
        maoComment: comment,
        maoOfferPrice: price,
        maoOfferQty: qty,
      }
    }

    const result = await instance.post(`/bid/${endpoint}`, actionData)

    const {
      data: { success, msg },
    } = result

    if (success && type === 'mao') {
      setOffers(offers && offers?.length ? [...offers, item.id] : [item.id])
    }

    if (success && type === 'bin') {
      setBins(bins && bins?.length ? [...bins, item.id] : [item.id])
    }

    setFeedback(msg)
    setIsSubmitted(success)
  }

  const resetModal = () => {
    toggleModal(false, 'BinMao')
    setTimeout(() => {
      setIsSubmitted(undefined)
    }, 300)
  }

  const handlePriceChange = (val: any) => {
    setPrice(parseFloat(val))
  }

  const handleCheckClick = () => {
    setChecked((prevState: any) => !prevState)
  }

  useEffect(() => {
    const closeModal = (e: any) => {
      if (e.key === 'Escape') {
        resetModal()
      }
    }
    window.addEventListener('keyup', closeModal)
    return () => window.removeEventListener('keyup', closeModal)
  }, []) // eslint-disable-line

  useEffect(() => {
    const options = []

    for (let i = 1; i <= item.quantity; i += 1) {
      const option = { label: `${i}`, value: i }
      options.push(option)
    }

    setPrice(priceVal)
    setQtyOpts(options)
  }, [item.quantity]) // eslint-disable-line

  useEffect(() => {
    setPrice(priceVal)
    setIsSubmitted(undefined)
  }, [type]) // eslint-disable-line

  return (
    <div
      className={`transition-opacity duration-200 fixed top-0 flex justify-center items-center w-full h-screen p-4 xl:pl-50 bg-black/30 ${
        negativeZ ? styles.hide_modal : styles.show_modal
      } ${!showModal ? ` opacity-0` : 'opacity-100'}`}
      role="none"
      onClick={() => resetModal()}
    >
      {terms && (
        <div
          className={`${styles.modal} relative bg-white rounded-lg max-h-full	overflow-y-scroll`}
          role="none"
          onClick={(e: any) => e.stopPropagation()}
        >
          <button
            className="absolute top-0 right-0 px-3 py-1 text-white text-xl"
            type="button"
            onClick={() => resetModal()}
          >
            &times;
          </button>
          <div className="py-2 px-6 rounded-t-lg bg-bidfta-blue-light text-white font-bold text-sm">
            {title}
          </div>
          {isSubmitted === undefined || isSubmitted === false ? (
            <>
              <div className="p-4 pb-0">
                <div className="lg:flex">
                  <div className="flex w-full lg:w-1/3 lg:h-full">
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      className="w-full h-full object-cover object-center rounded-t-xl lg:rounded-t-none lg:rounded-l-xl"
                    />
                  </div>
                  <div className="w-full lg:w-2/3 mt-4 lg:mt-0 lg:pl-4">
                    <div className="mb-2 font-bold">{item.title}</div>
                    <div className="mb-2">
                      {type === 'bin' && (
                        <div className="text-sm">
                          <span className="font-bold">Buy It Now Price: </span>
                          <span>${price}</span>
                        </div>
                      )}
                      {type === 'mao' && (
                        <BidInput
                          inputValue={price}
                          setInputValue={handlePriceChange}
                          theme="blue"
                          label="Offer Price"
                          labelBold
                          size="default"
                          required
                          type="number"
                          twcss="text-sm"
                        />
                      )}
                    </div>
                    <div className="mb-2">
                      <BidSelect
                        options={qtyOpts}
                        label="Qty"
                        selectValue={qty}
                        setSelectValue={setQty}
                        theme="blue"
                        size="default"
                        twcss="text-sm font-bold"
                      />
                    </div>
                    <div className="text-sm">
                      <span className="font-bold">Total: </span>
                      <span>
                        {formatPrice(parseFloat(price) * parseFloat(qty))}
                      </span>
                    </div>
                    <div className="text-xs text-bidfta-red">
                      <span className="font-bold">
                        {`Price including premium and tax: ${totalPremiumTax(
                          price,
                          qty,
                          premiumRate,
                          location.taxRate
                        )}`}
                      </span>
                    </div>

                    {type === 'mao' && (
                      <div className="mt-2">
                        <label htmlFor="comments" className="font-bold text-sm">
                          Comments
                          <textarea
                            name="comments"
                            className="block w-full rounded-md border px-4 text-bidfta-gray-dark border-bidfta-gray-fieldborder focus:outline-none bg-white text-base focus:border-bidfta-blue py-2"
                            onChange={(e: any) => setComment(e.target.value)}
                          />
                        </label>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mt-4">
                  <div className="font-bold">Terms and Conditions</div>
                  <div className="p-2 h-40 border border-bidfta-gray-border text-sm overflow-y-scroll">
                    {terms.map((term: any) => (
                      <div key={term.keyId}>
                        <p className="font-bold">{term.keyName}</p>
                        <p className="mb-2">{term.keyValue}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap justify-between items-center p-4">
                <label
                  htmlFor="agree"
                  className={`${checkStyles.check__label} flex relative items-center justify-start`}
                  onClick={handleCheckClick}
                  role="button"
                  onKeyDown={(e: any) =>
                    e.key === 'Enter' && handleCheckClick()
                  }
                  tabIndex={0}
                >
                  <div className="checkbox cursor-pointer inline-block">
                    {checked && (
                      <svg
                        id="Layer_1"
                        version="1.1"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="#297AF7"
                      >
                        <g>
                          <polygon
                            className="st0"
                            points="434.8,49 174.2,309.7 76.8,212.3 0,289.2 174.1,463.3 196.6,440.9 196.6,440.9 511.7,125.8 434.8,49     "
                          />
                        </g>
                      </svg>
                    )}
                  </div>
                  <input
                    id="agree"
                    name="agree"
                    type="checkbox"
                    checked={checked}
                    onChange={() => {
                      setChecked((prevState: any) => !prevState)
                    }}
                  />
                  <span className="pl-4 inline-block">I agree</span>
                </label>

                <div className="flex">
                  <div>
                    <BidButton
                      label="Cancel"
                      theme="gray"
                      buttonStyle="hollow"
                      callBack={() => toggleModal(false, 'BinMao')}
                      width="full"
                    />
                  </div>
                  <div className="ml-2">
                    <BidButton
                      label={actionLabel}
                      theme="blue"
                      callBack={() => handleAction()}
                      width="full"
                      disabled={!checked || price <= 0}
                    />
                  </div>
                </div>

                {feedback && (
                  <div
                    className={`mt-1 w-full text-right text-sm text-bidfta-${
                      isSubmitted ? 'green' : 'red'
                    }`}
                  >
                    {parse(feedback).structuredText}
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="w-80 p-4 text-center">
              <svg
                className="mx-auto mb-3"
                width="58"
                height="59"
                viewBox="0 0 58 59"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="29"
                  cy="29.959"
                  r="27"
                  fill="#439A86"
                  stroke="#439A86"
                  strokeWidth="4"
                />
                <path
                  d="M14.1729 32.1931L24.5543 42.5746L43.8999 23.229"
                  stroke="white"
                  strokeWidth="4"
                />
              </svg>
              Thank you for{' '}
              {type === 'bin' ? 'your purchase' : 'making an offer'}.
            </div>
          )}
        </div>
      )}
    </div>
  )
}
